import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";

export default function GroupChatSearch({
  search = "",
  fetchChannels,
  fetchAllUser,
  createNewChannelSection,
}) {
  const [timeoutId, setTimeoutId] = useState(null);

  const handleSearch = (e) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTimeoutId(
      setTimeout(() => {
        const searchQuery = e.target.value;
        if (createNewChannelSection === 4) {
          fetchAllUser(1, searchQuery.trim());
        }
        if (createNewChannelSection === 0) {
          fetchChannels(true, 1, searchQuery.trim()); // Fetch channels with the search query
        }
      }, 300)
    );
  };
  return (
    <div className="w-full max-w-md sticky">
      <input
        defaultValue={search}
        onKeyDown={(e) => handleSearch(e)}
        type="text"
        placeholder={`Search ${createNewChannelSection != 4 ? "Channel": "Follower"}`}
        className="input bg-inherit h-12 rounded-lg border border-[#EBEBEB] input-bordered w-full pl-10 py-[12px] placeholder:text-black"
      />
      <FiSearch className="absolute left-3 top-8 transform -translate-y-1/2 text-black" />
    </div>
  );
}
